import ImportIcon from "@mui/icons-material/ExitToAppRounded";
import { Button } from "@mui/material";
import { useState } from "react";
import type { WorkflowType } from "@entrilia/shared/api/workflowTypes";
import useFetch from "@entrilia/shared/hooks/useFetch";
import { logError } from "@entrilia/shared/logging";
import adminApi from "../../../../api/adminApi";
import useClientContext from "../../../../context/useClientContext";
import UploadDocumentsDialog from "../document-workflows/UploadDocumentsDialog";

interface Props {
  workflowType: WorkflowType;
  templateId?: string;
  onWorkflowsStarted?: () => void;
}

const documentWorkflowTypes: WorkflowType[] = [
  "InvoiceProcessing",
  "InvestmentAcquisition",
  "FundCapitalCallDistribution",
  "PcapUpload",
];

const UploadDocumentsButton = ({ workflowType, templateId, onWorkflowsStarted }: Props) => {
  const { hasPermissions } = useClientContext();
  const [dialogOpen, setDialogOpen] = useState(false);

  const isVisible = hasPermissions(["ManageWorkflows"]) && documentWorkflowTypes.includes(workflowType);

  const shouldFetchWorkflowGroups = isVisible && !templateId;

  const [workflowGroups, fetchError] = useFetch(adminApi.getWorkflowGroups, {
    disabled: !shouldFetchWorkflowGroups,
  });

  if (fetchError) {
    logError(fetchError, "[UploadDocumentsButton] getWorkflowGroups");
  }

  const resolvedTemplateId = templateId ?? workflowGroups?.find((g) => g.workflowType === workflowType)?.templateId;

  if (!isVisible || !resolvedTemplateId) {
    return null;
  }

  return (
    <>
      <Button variant="outlined" color="secondary" onClick={() => setDialogOpen(true)} startIcon={<ImportIcon />}>
        Upload Documents
      </Button>

      {dialogOpen && (
        <UploadDocumentsDialog
          onClose={(workflowsStarted) => {
            setDialogOpen(false);
            if (workflowsStarted) {
              onWorkflowsStarted?.();
            }
          }}
          mode={{ kind: "run", workflowType, templateId: resolvedTemplateId }}
        />
      )}
    </>
  );
};

export default UploadDocumentsButton;
